import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://tribhus.net';

// Criar instancia do axios com configuracoes base
// ALTO-009b: withCredentials envia o cookie HttpOnly (adminAccessToken) cross-site.
const api: AxiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Interceptor para adicionar token em todas as requisicoes
// ALTO-009b (fase 1): ainda envia Bearer se houver token legado no localStorage.
// Fase 2 removera esta leitura depois que todas as sessoes migrarem para cookie.
api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para tratar erros de autenticacao
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // ALTO-009b: avisa backend para limpar cookie (idempotente) + limpa legado.
      try {
        await axios.post(`${API_URL}/admin-auth/logout`, {}, { withCredentials: true });
      } catch (_) { /* ignora erro de logout */ }
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_data');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
